import React from "react";
import { Provider } from "react-redux";

import initializeStore from "shared/redux-store/initializeStore";

import { IntlProvider, addLocaleData } from "react-intl";
import de from "react-intl/locale-data/de";

// Initializes the redux store & i18n
export default class App extends React.Component {
  constructor(props) {
    super(props);

    addLocaleData([...de]);

    this.state = {
      store: this.createStore(),
    };

    initializeStore(this.state.store); // Note: Deprecated
  }

  componentWillMount() {
    this.dispatchInjectedActions(this.props.actions); // Note: Deprecated
  }

  getStore() {
    return this.state.store;
  }

  getLocale() {
    return this.state.store && this.state.store.getState().app.locale;
  }

  dispatchInjectedActions(actions) {
    const injectedActions = actions || [];
    injectedActions.forEach(action => {
      this.state.store.dispatch({
        type: action.type,
        payload: action.payload,
      });
    });
  }

  i18nMessages() {
    throw new Error("abstract"); // needs to be overwritten in inheriting class
  }

  createStore() {
    throw new Error("abstract"); // needs to be overwritten in inheriting class
  }

  renderApp() {
    throw new Error("abstract"); // needs to be overwritten in inheriting class
  }

  render() {
    return (
      <Provider store={this.getStore()}>
        <IntlProvider locale={this.getLocale()} messages={this.i18nMessages()}>
          {this.renderApp()}
        </IntlProvider>
      </Provider>
    );
  }
}
